import { Updatable } from '../../..';

export default class PayPalSettings extends Updatable {
    public email: string;

    update(entity: Partial<PayPalSettings>, allowUndefined = false) {
        super.update(entity, allowUndefined);
    }
}